import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const ROLES = ["admin", "user"];

const COLORS = {
  owner: { bg: "#edebfe", fg: "#5f2eba" },
  admin: { bg: "#def7ec", fg: "#488775" },
  user: { bg: "#f3f4f6", fg: "#6b7280" },
};

const STYLE = {
  padding: "4px 12px", borderRadius: "999px", fontSize: "13px",
  fontWeight: 600, textTransform: "capitalize", display: "inline-block",
  minWidth: "64px", textAlign: "center", border: "none", lineHeight: "20px",
};

export default function UserStatusDropdown({ currentRole, onRoleChange, disabled }) {
  const [role, setRole] = useState(currentRole);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const btn = useRef(null);
  const menu = useRef(null);

  useEffect(() => setRole(currentRole), [currentRole]);

  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (menu.current?.contains(e.target) || btn.current?.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const c = COLORS[role] || COLORS.user;
  const bs = { ...STYLE, backgroundColor: c.bg, color: c.fg, cursor: disabled ? "default" : "pointer" };

  const toggle = () => {
    if (disabled) return;
    if (!open && btn.current) {
      const r = btn.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left });
    }
    setOpen(!open);
  };

  const change = async (name) => {
    const prev = role;
    setRole(name);
    setOpen(false);
    try { await onRoleChange(name); } catch { setRole(prev); }
  };

  return (
    <>
      {disabled ? (
        <span style={bs}>{role}</span>
      ) : (
        <button ref={btn} type="button" style={bs} onClick={toggle}>{role}</button>
      )}
      {open && pos && createPortal(
        <div ref={menu} style={{
          position: "fixed", top: pos.top, left: pos.left, background: "#fff",
          border: "1px solid #e5e7eb", borderRadius: 8,
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 9999, overflow: "hidden",
        }}>
          {ROLES.map(name => (
            <button key={name} type="button" disabled={name === role}
              onClick={() => change(name)}
              onMouseEnter={e => e.target.style.background = name === role ? "#f9fafb" : "#f3f4f6"}
              onMouseLeave={e => e.target.style.background = name === role ? "#f9fafb" : "#fff"}
              style={{
                display: "block", width: "100%", padding: "8px 16px",
                textAlign: "left", fontSize: 14, textTransform: "capitalize",
                border: "none", cursor: name === role ? "default" : "pointer",
                background: name === role ? "#f9fafb" : "#fff",
                color: name === role ? "#9ca3af" : "#111827",
              }}
            >
              {name}
            </button>
          ))}
        </div>,
        document.body
      )}
    </>
  );
}
